import logger from '../utils/logger';
import React, { useEffect, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const { processOAuthSession, setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  const handleCallback = useCallback(async () => {
    // Extract session_id from URL fragment
    const hash = location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      logger.error('No session_id in callback');
      navigate('/login');
      return;
    }

    try {
      const userData = await processOAuthSession(sessionId);
      setUser(userData);
      // Navigate to dashboard with user data
      navigate('/dashboard', { state: { user: userData }, replace: true });
    } catch (error) {
      logger.error('OAuth callback error:', error);
      navigate('/login');
    }
  }, [location.hash, navigate, processOAuthSession, setUser]);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    handleCallback();
  }, [handleCallback]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin mx-auto mb-4 text-primary" />
        <p className="text-muted-foreground">Authenticating...</p>
      </div>
    </div>
  );
}
